import { executeCubeQuery, isCubeMock } from "@/services/cubeApi";
import { mockFetch } from "../mockFetch";
import { createDataWidget } from "../createDataWidget";
import { SERIAL_LIST_DIMENSIONS, mapSerialRows } from "./logic";
import { generateSerialRows } from "./mock";
import type { SerialEntry } from "./types";

/**
 * App-wide reference-data widget (headless — no chart/table UI): the machine
 * serial list from the `Dbo520serial` table. Every page shares ONE Redux
 * slice; the fetch is dispatched exactly once per session (startup in
 * `main.tsx`, or lazily by `useSerialList` on a direct page load) and the
 * cache then serves all consumers. The serial filter reads the same slice
 * instead of refetching per widget.
 *
 * Mock mode (no backend): `mock.ts` generates rows in the exact real
 * response shape — printer pairs `1000/1001` (front/back) grouped by machine
 * line (HD/HDX/NX) — fed through the same `mapSerialRows` pipeline.
 */
const realFetcher = async (_params: void, signal: AbortSignal): Promise<SerialEntry[]> => {
  const { rows } = await executeCubeQuery(
    { dimensions: [...SERIAL_LIST_DIMENSIONS] },
    signal,
  );
  return mapSerialRows(rows);
};

export const serialList = createDataWidget<SerialEntry, void>({
  name: "serialList",
  fetcher: isCubeMock()
    ? mockFetch(() => mapSerialRows(generateSerialRows()))
    : realFetcher,
});
